export default "__VITE_ASSET__K74WOV9k__"